import { emergencyContactsAdapterSelectors } from '../redux/slices/emergencyContacts';
import { createSelector } from 'reselect';
import { defaultResourceSelector } from './defaultSelectorUtils';

const getCurrentWorkspaceEmergencyContactsFromStore = (state) =>
  state.currentWorkspace.emergencyContacts;

export const currentWorkspaceEmergencyContacts = createSelector(
  getCurrentWorkspaceEmergencyContactsFromStore,
  (state) => (id) => emergencyContactsAdapterSelectors.selectById(state, id),
  (emergencyContactIds, getEmergencyContactById) =>
    emergencyContactIds.map((emergencyContactId) =>
      defaultResourceSelector({
        main: {
          resourceId: emergencyContactId,
          getResourceById: getEmergencyContactById,
        },
      })
    )
);
